import React from "react";
import { formatCurrency } from "../lib/api";
import { ShieldCheck, Warning, WarningOctagon, Tag } from "@phosphor-icons/react";

export const MARGIN_STATUS = {
  saudavel: { label: "Margem saudável", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: ShieldCheck },
  apertada: { label: "Margem apertada", cls: "bg-amber-50 text-amber-800 border-amber-200", icon: Warning },
  risco: { label: "Em risco: abaixo do mínimo", cls: "bg-rose-50 text-rose-700 border-rose-200", icon: WarningOctagon },
};

export function MarginBadge({ analysis, priceIdeal, priceMinimum, testId }) {
  if (!analysis) return null;
  if (analysis.status === "sem_preco") {
    return (
      <div className="mt-3 text-xs text-slate-500 flex items-start gap-1.5 flex-wrap" data-testid={testId}>
        <Tag size={14} className="mt-0.5 shrink-0" /><span>Informe quanto você cobra hoje para ver a saúde da margem. Desconto máximo sobre o ideal: <strong className="font-mono-nums">{analysis.max_discount_pct}%</strong></span>
      </div>
    );
  }
  const st = MARGIN_STATUS[analysis.status];
  return (
    <div className={`mt-3 rounded-md border px-3 py-2 text-xs ${st.cls}`} data-testid={testId}>
      <div className="flex items-center gap-1.5 font-semibold"><st.icon size={15} weight="fill" /> {st.label} · você cobra <span className="font-mono-nums">{formatCurrency(analysis.current_price)}</span> (margem {analysis.current_margin_pct}%)</div>
      <div className="mt-1 flex flex-wrap gap-x-4 gap-y-0.5">
        {analysis.status === "risco"
          ? <span>Abaixo do mínimo de <strong className="font-mono-nums">{formatCurrency(priceMinimum)}</strong>. Suba pelo menos <strong className="font-mono-nums">{formatCurrency(priceMinimum - analysis.current_price)}</strong>.</span>
          : <span>Limite de desconto: <strong className="font-mono-nums">{formatCurrency(analysis.max_discount_amount)}</strong> ({analysis.max_discount_pct}%)</span>}
        {analysis.gap_to_ideal > 0 && <span>Faltam <strong className="font-mono-nums">{formatCurrency(analysis.gap_to_ideal)}</strong> para o ideal</span>}
      </div>
    </div>
  );
}
